module.exports = __webpack_public_path__ + "static/media/CHI Papers ReadMe.99f092d4.txt";